import Slider from 'react-slick';
import React, { useEffect, useMemo } from 'react';
import RecentlyViewedCard from './RecentlyViewedCard';
import { faOnRecentViewedSectionLoad } from './analytics-services';
import { getMMT_HLD_OBJ } from '../../../../../../../../common/utils/appUtils';
import './styles.scss';

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 2.8,
  slidesToScroll: 1,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.8,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
      },
    },
  ],
};

const RecentlyViewSection = ({ sectionData }) => {
  useEffect(() => {
    faOnRecentViewedSectionLoad();
  }, []);

  const shouldDisplayArrow = useMemo(() => sectionData?.cards?.length >= 3, [sectionData]);

  return (
    !!sectionData?.cards?.length &&
    !getMMT_HLD_OBJ().fromSEO && (
      <div className="recentlyViewSection">
        <div className="recentlyViewedHeader">
          <h2>Recently Viewed</h2>
          {shouldDisplayArrow && (
            <span className="slideArrow pushRight hideControls">
              <span className="lineSpacing">|</span>
            </span>
          )}
        </div>
        <div className="recentlyViewedSlider">
          <Slider {...settings}>
            {sectionData?.cards?.map((cardDeatils, index) => (
              <RecentlyViewedCard
                packageDetails={cardDeatils}
                sectionIndex={sectionData?.order}
                cardIndex={index}
                key={cardDeatils?.packageId}
              />
            ))}
          </Slider>
        </div>
      </div>
    )
  );
};

export default RecentlyViewSection;
